import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteAnaliseMercadoFormModule } from '../cliente-analise-mercado-form.module';

import { ClienteAnaliseMercadoFormModalComponent } from './cliente-analise-mercado-form-modal.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoFormModule
    ],
    declarations: [
        ClienteAnaliseMercadoFormModalComponent
    ],
    exports: [
        ClienteAnaliseMercadoFormModalComponent
    ]
})
export class ClienteAnaliseMercadoFormModalModule { }
